import { getAppConfigSetting, requests } from 'utils';
import { UPDATE_WIRES_URL } from './constants';

export function updateWireRequest(transferId, payload) {
  return requests.put(`${UPDATE_WIRES_URL(getAppConfigSetting('apiUrl'), transferId)}`, JSON.stringify(payload));
}



// WEBPACK FOOTER //
// ./src/services/updateWire/api.js